module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_endscopy/check_circle-9d8173fa3a1d8175423d5115d603fa07.svg";